<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i :class="user.id == null ? 'bi bi-person-plus' : 'bi bi-pencil'"></i>
        {{ user.id == null ? 'Nuevo usuario' : 'Editar usuario' }}
      </h6>
      <button v-if="user.id != null" type="button" class="form-card__btn" @click="resetForm">
        <i class="bi bi-plus-lg"></i>
        Nuevo
      </button>
    </div>

    <div class="form-card__body">
      <form @submit.prevent="saveUser">
        <div class="form-card__field">
          <label class="form-card__label" for="user-name">Nombre completo</label>
          <input
            id="user-name"
            v-model.trim="user.name"
            type="text"
            class="form-control"
            placeholder="Nombre completo"
          />
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="user-email">Email</label>
          <input
            id="user-email"
            v-model.trim="user.email"
            type="email"
            class="form-control"
            placeholder="email@ejemplo.com"
            autocomplete="off"
          />
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="user-password">Contraseña</label>
          <input
            id="user-password"
            v-model="user.password"
            type="password"
            class="form-control"
            placeholder="Contraseña"
            autocomplete="new-password"
          />
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="user-password-confirm">Confirmar contraseña</label>
          <input
            id="user-password-confirm"
            v-model="user.password_confirmation"
            type="password"
            class="form-control"
            placeholder="Confirmar contraseña"
            autocomplete="off"
          />
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="user-branchoffice">Sucursal</label>
          <select id="user-branchoffice" v-model="user.branchoffice_id" class="form-control">
            <option :value="null" disabled>Seleccioná una sucursal</option>
            <option v-for="branchOffice in branchOffices" :key="branchOffice.id" :value="branchOffice.id">
              {{ branchOffice.name }}
            </option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label" for="user-role">Rol de acceso</label>
          <select id="user-role" v-model="user.role_id" class="form-control">
            <option :value="null" disabled>Seleccioná un rol</option>
            <option v-for="role in roles" :key="role.id" :value="role.id">
              {{ role.name }}
            </option>
          </select>
        </div>

        <div class="form-card__field">
          <label class="form-card__label">Cajas</label>
          <treeselect
            v-model="user.funds_linked"
            class="multiList"
            :options="funds"
            :multiple="true"
            :flat="true"
            :autoSelectAncestors="true"
            :autoDeselectDescendants="true"
            :open-on-click="true"
            value-consists-of="ALL_WITH_INDETERMINATE"
            placeholder="Seleccioná cajas..."
          />
        </div>
      </form>
    </div>

    <div class="form-card__footer">
      <button type="button" class="form-card__btn form-card__btn--primary" :disabled="isSaving" @click="saveUser()">
        <i class="bi bi-check-lg"></i>
        Guardar usuario
      </button>
    </div>
  </div>
</template>
<script>
import Treeselect from '@riophae/vue-treeselect'


export default {
  components: {Treeselect},
  props: ['userId'],
  mounted() {
    this.getRolesData();
    if (this.userId != null) {
      this.getUser(this.userId);
    } else {
      this.resetForm();
    }
    this.getFunds();
  },
  data: function () {
    return {
      modo: 'nuevo',
      isSaving: false,
      user: {
        name: '',
        email: '',
        password: null,
        password_confirmation: null,
        branchoffice_id: null,
        role_id: null,
        funds_linked:[],
      },
      emptyUser: {
        name: '',
        email: '',
        password: null,
        password_confirmation: null,
        branchoffice_id: null,
        role_id: 1,
        funds_linked:[],
      },
      roles: [],
      branchOffices: [],
      selected: null,
      funds: [],
    };
  },
  computed: {
    
  },
  watch: {
    userId: function(value) {
      if (value != null) {
        this.getUser(value);
      } else {
        this.resetForm();
      }            
    }
  },
  methods: {
    getRolesData() {
      const vm = this;
      this.$http
        .get('/api/configs/role/getData', {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        })
        .then((response) => {
          vm.roles = response.data.data.roles;
          vm.branchOffices = response.data.data.branchoffices;
        });
    },
    saveUser() {
      if (this.isSaving) return;
      this.isSaving = true;
      var vm = this;
      if (vm.user.id != null) {
        vm.$http
          .post(`/api/users/edit/${vm.user.id}`, vm.user)
          .then(() => {

            vm.resetForm();
            vm.$emit("confirmsave");
          })
          .finally(() => {
            vm.isSaving = false;
          });
      } else {
        this.$http
          .post("/api/users/add", vm.user)
          .then(() => {

            vm.resetForm();
            vm.$emit("confirmsave");
          })
          .finally(() => {
            vm.isSaving = false;
          });
      }
    },
    getUser(id) {
      var vm = this;
      this.modo = "editar";
      this.$http.get(`/api/users/show/${id}`)
      .then((response) => {
        // const { id, description, name, permissions } = response.data.data;
        // const allowed = permissions.map(perm => perm.id);
        // vm.role = { id, description, name, allowed };
        const user = response.data.data;
        vm.user = {...user, branchoffice_id: user.bo_id};

      });
    },
    getFunds() {
      var vm = this;
      this.$http.get(`/api/funds/getFunds`)
      .then((response) => {
        vm.funds = response.data.data.map(function (item) {
          item.label = item.name
          return item
        });
      });
    },
    resetForm() {
      this.user = Object.assign({}, this.emptyUser);
    },
  }
}

</script>